import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, public http: HttpClient, private router: Router) { this.ping(), this.currency(), this.operator(), this.site(), this.getsiteName() }
  channelID: string;
  viewMode = 'tab1';
  channel: any = [];
  siteInfo: any = [];
  loaded: boolean = true;
  tag: any;
  myData: any;
  subChannel: boolean;
  ozowDataBool: boolean = false;
  subSite: boolean;
  bouquetUser: boolean;
  playlists: any = [];
  sliderOptions = { dots: false, navigation: true, nav: false, autoplay: false, loop: false, autoplayTimeout: 2000, autoplayHoverPause: true, lazyLoad: true, responsive: { 0: { items: 1 }, 600: { items: 2 }, 960: { items: 4 }, 1200: { items: 4 } } };
  contents: any;
  content: any;
  playlist: any;
  sitebillingAgent: any;
  siteRenew: any;
  channelbillingAgent: any;
  products: any = [];
  currencySign: any;
  subscriptionStatusId: any;
  subscribeData: any = [];
  billingID = '';
  cost = '';
  siteName = '';
  agent = '';
  profileData: any = [];
  profileID = '';
  ozowData: any = [];
  productBillingID = '';
  counter = 0;
  max = 60;
  intervalManage: any;
  tryAgain: boolean = false;
  failed: boolean = false;
  siteID = environment.siteID;
  public ping() {
    this.route.params.subscribe(params2 => {
      this.channelID = params2['channelID'];
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getChannel?siteID='+this.siteID+'&channelID=' + this.channelID, {
        headers: myheader
      })
        .subscribe(
          data => {
            console.log('getChannel Data');
            console.log(data);
            this.channel = data;
            this.playlists = data['playlists'];
            this.contents = [];// reset to empty list.
            this.subChannel = this.channel.userSubscribed;
            this.subSite = this.channel.subscribedToSite;
            this.channelbillingAgent = this.channel.billingAgent.name;
            this.bouquetUser = this.channel.withBouquet;
            this.playlists.forEach(playlist => {
              playlist.contents.forEach(content => {
                this.contents.push(content);
              });

            });

          },
          error => {
            if (error.status >= 400 && error.status < 500) { 
              this.ngxSmartModalService.create('myModal1', '').open();
            }
         else if (error.status >= 500) { 
location.reload();
        }
            console.log('ERROR:');
            console.log(error);
          }
        );
    });
  }
  public getsiteName() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
    let body = new HttpParams();
    this.http.get('https://api-staging.videyo.tv/endpoint/getSite?siteID='+this.siteID, {
      headers: myheader
    })
      .subscribe(
        data => {
          this.siteName = data['name'];
          this.sitebillingAgent =data['billingAgent']
          console.log(this.sitebillingAgent);

        },
        error => {
        }
      );
  }
  public site() {
    this.route.params.subscribe(params2 => {
      this.billingID = params2['id'];
      this.cost = params2['cost'];
      this.siteRenew = params2['billingFrequency'];
      this.currencySign = params2['currency'];
      this.agent = params2['billingAgent'];
      if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'DAILY') {
        this.siteRenew = 'يومي';
      }
      else if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'WEEKLY') {
        this.siteRenew = 'أسبوعي';
      }
      else if (window.location.href.indexOf("/ar/") > -1 && this.siteRenew == 'MONTHLY') {
        this.siteRenew = 'شهري';
      }
      if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'DAILY') {
        this.siteRenew = 'Chaque jour';
      }
      else if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'WEEKLY') {
        this.siteRenew = 'Chaque semaine';
      }
      else if (window.location.href.indexOf("/fr/") > -1 && this.siteRenew == 'MONTHLY') {
        this.siteRenew = 'Chaque mois';
      }
      this.currencySign = this.siteInfo.currency.sign;
      if (window.location.href.indexOf("/ar/") > -1) { 
        this.currencySign = this.siteInfo.currency.alternativeSigns.ar;
      }
      else { 
        this.currencySign = this.siteInfo.currency.sign;
      }
  });
}
  subscribeSite() {
    var tempURL = 'https://staging.videyo.tv/billing/subscribe?siteID='+this.siteID+'&productBillingID='+this.billingID+'&successUrl='+encodeURIComponent(environment['unencodeLink'])+'&cancelUrl='+encodeURIComponent(environment['unencodeLink'])+'&errorUrl='+encodeURIComponent(environment['unencodeLink'])
    this.http.get(tempURL, {}).subscribe(
      data => {
        this.subscribeData = data;
        this.ozowData = this.subscribeData['ozowDetails'];
       
        console.log('OZOW DATA');
        console.log(this.ozowData);
        this.subscriptionStatusId = this.subscribeData.id;
        if(this.ozowData) { 
          this.subSite = true;
          this.ozowDataBool = true;
        }
        else if (data['needsOTP']) {
          this.router.navigate(['/subscribe-confirm/' + this.subscriptionStatusId]);
        }
        else {
          this.loaded = false;
          this.checkSubscription();
        }

      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
    )
  }
  public checkSubscription() {
    this.counter++;
    if (this.counter > this.max) {
      clearInterval(this.intervalManage);
      this.failed = true;
    }
    else {
      const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
      this.http.get('https://api-staging.videyo.tv/endpoint/getSubscriptionStatus?siteID='+this.siteID+'&subscriptionStatusId=' + this.subscriptionStatusId, {
        headers: myheader
      })
        .subscribe(
          data => {
            console.log(data);
            this.profileData = data['status'];
            console.log(data['status']);
            if (data['status'] == 'PENDING') {
              if (this.tryAgain == false) {
                this.tryAgain = true;
                this.checkSubAgain();
              }
            }
            else if (data['status'] == 'PAID') {
              clearInterval(this.intervalManage);
              this.tryAgain = false;
              this.router.navigate(['/']);

            }
            else { 
              this.failed = true;
            }
          },
          error => {

          }
        );
    }
  }
  checkSubAgain() {
    console.log('starting timer');
    this.intervalManage = setInterval(() => { this.checkSubscription(); }, 5000);
    console.log(this.intervalManage);
  }
  subscribeChannel() {
    var tempURL = 'https://staging.videyo.tv/billing/subscribe?channelId=' + this.channelID;

    this.http.get(tempURL, {}).subscribe(
      data => {
        this.subscribeData = data;
        this.subscriptionStatusId = this.subscribeData.id;
        this.router.navigate(['/subscribe-confirm/' + this.subscriptionStatusId]);
      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
    )
  }
  currencyType: any[];
  operatorType: any[];
  name: string = '';
  mobNum: string = '';
  email: string = '';
  password: string = '';
  currencyChoice: string = '';
  mobOperatorChoice: string = '';
  preferredCountries = ['za', 'us', 'au', 'ru', 'gb'];
  onMobNumKeyUp(event: any) {
    this.mobNum = event.target.value;

  }
  onNameKeyUp(event: any) {
    this.name = event.target.value;

  }
  onEmailKeyUp(event: any) {
    this.email = event.target.value;

  }
  onPasswordKeyUp(event: any) {
    this.password = event.target.value;

  }
  onCurrencyChoice(event: any) {
    this.currencyChoice = event.target.value;

  }
  onMobOperatorChoice(event: any) {
    this.mobOperatorChoice = event.target.value;

  }
  public currency() {
    this.http.get('https://api-staging.videyo.tv/manage/listCurrencies', {
    })
      .subscribe(
        data => {
          this.currencyType = data['currency'];
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
  }
  public operator() {
    this.http.get('https://api-staging.videyo.tv/manage/listMobileOperators', {
    })
      .subscribe(
        data => {
          this.operatorType = data['mobileOperator'];
        },
        error => {
          if (error.status >= 400 && error.status < 500) { 
            this.ngxSmartModalService.create('myModal1', '').open();
          }
          else if (error.status >= 500) { 
            this.ngxSmartModalService.create('myModal2', '').open();
            
          }
          console.log('ERROR:');
          console.log(error);
        }
      );
  }
  public postProfile() {
    var tempURL = 'https://api-staging.videyo.tv/manage/register?phoneNumber=' + this.mobNum.replace('+', '') + '&password=' + this.password + '&name=' + this.name + '&email=' + encodeURIComponent(this.email) + '&currencyId=' + this.currencyChoice + '&mobileOperatorId=' + this.mobOperatorChoice;
    this.http.post(tempURL, {}).subscribe(
      data => {

      },
      error => {
        if (error.status >= 400 && error.status < 500) { 
          this.ngxSmartModalService.create('myModal1', '').open();
        }
        else if (error.status >= 500) { 
location.reload();
        }
        console.log('ERROR:');
        console.log(error);
      }
    )

  }



  ngOnInit() {
  }

}
